import React from "react";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { getLocalizedString } from "@icarius-localization/strings";
import { COLUMN_PATHS } from "@icarius-pages/modulesAndMenus/columnDef";
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import MenuItemWithIcon from "@icarius-common/MenuItemWithIcon";
import ModuleFormDialog from "./moduleFormDialog";
import useModules from "./useModules";
import TreeDialog from "./treeDialog";

const Modules = () => {

  const {
    isLoading,
    modules,
    collaboratorsList,
    tree,
    resources,
    state,
    handlers,
  } = useModules();

  const editButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenUpdateForm(gridRef)}
      type={"edit"}
    />
  )

  const viewTreeButton = () => (
    <CustomIconButton
      title={getLocalizedString("viewVisualizationTree")}
      onClick={handlers.handleOpenTreeDialog}
    >
      <AccountTreeIcon />
    </CustomIconButton>
  )

  const helpItems = resources?.map((resource, index) => {
    return (
      <MenuItemWithIcon key={index} value={resource.path} text={resource.name} type={"file"} />
    )
  })

  return (
    <CommonPage
      isLoading={isLoading}
      gridTitle={getLocalizedString("modules")}
      helpItems={helpItems}
      rowData={modules}
      menuItems={[editButton, viewTreeButton]}
      columnDefPage={COLUMN_PATHS.modules}
      hasExpand
      hasHelp
    >
      {
        state.formIsOpen &&
        <ModuleFormDialog
          open={state.formIsOpen}
          data={state.selectedItem}
          isLoading={isLoading}
          submitCallback={handlers.handleUpdate}
          handleClose={handlers.handleCloseForm}
        />
      }
      {
        state.treeDialogIsOpen &&
        <TreeDialog
          open={state.treeDialogIsOpen}
          data={tree}
          collaboratorsList={collaboratorsList}
          isLoading={isLoading}
          handleClose={handlers.handleCloseTreeDialog}
        />
      }
    </CommonPage>
  )
}

export default Modules;